import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { useSettings } from "../../lib/settings";
import { telHref, DIVISIONS } from "../../lib/api";

const cols = [
  { title: "Company", links: [["/about", "About Us"], ["/divisions", "Our Divisions"], ["/how-it-works", "How It Works"], ["/reviews", "Client Reviews"], ["/business-opportunities", "Business Opportunities"], ["/careers", "Careers"], ["/contact", "Contact"]] },
  { title: "Inventory", links: [["/inventory", "All Inventory"], ...DIVISIONS.map((d) => [`/divisions/${d.key}`, d.name])] },
  { title: "Legal", links: [["/privacy", "Privacy Policy"], ["/terms", "Terms & Conditions"], ["/sourcing", "Asset Sourcing Requests"], ["/admin/login", "Staff Login"]] },
];

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="relative border-t hairline bg-[#080a10] grain overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5 space-y-6">
            <Logo />
            <p className="text-sm text-slate-300 leading-relaxed max-w-sm">
              An asset sourcing and brokerage company serving multiple industries through our Truck, Trailer, Marine and Equipment divisions.
            </p>
            <div className="space-y-3 text-sm text-slate-200" data-testid="footer-company-info">
              <p className="text-slate-400 text-xs uppercase tracking-[0.18em]">{s.company_name}</p>
              <p className="flex gap-3"><MapPin className="w-4 h-4 text-gold mt-0.5 shrink-0" /><span>{s.address_line1}<br />{s.address_line2}</span></p>
              <a href={telHref(s.phone)} className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-phone-link"><Phone className="w-4 h-4 text-gold mt-0.5" />{s.phone}</a>
              <a href={`mailto:${s.info_email}`} className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-info-email-link"><Mail className="w-4 h-4 text-gold mt-0.5 shrink-0" /><span><span className="text-slate-400">General: </span>{s.info_email}</span></a>
              <a href={`mailto:${s.sales_email}`} className="flex gap-3 hover:text-gold transition-colors" data-testid="footer-sales-email-link"><Mail className="w-4 h-4 text-gold mt-0.5 shrink-0" /><span><span className="text-slate-400">Sales: </span>{s.sales_email}</span></a>
            </div>
          </div>
          {cols.map((c, i) => (
            <div key={c.title} className={`lg:col-span-2 ${i === 0 ? "lg:col-start-7" : ""}`}>
              <p className="eyebrow mb-5">{c.title}</p>
              <ul className="space-y-3">
                {c.links.map(([to, label]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-slate-300 hover:text-gold transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="font-display italic text-[17vw] lg:text-[11rem] leading-none text-white/[0.04] mt-16 select-none whitespace-nowrap overflow-hidden">Selby Asset Group</p>
        <div className="mt-6 pt-6 border-t hairline flex flex-col md:flex-row gap-3 justify-between text-xs text-slate-400">
          <p>&copy; {new Date().getFullYear()} {s.company_name}. All rights reserved.</p>
          <p>Listings are subject to prior sale, change and verification. Please confirm all details before purchase.</p>
        </div>
      </div>
    </footer>
  );
};
